import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import InputItem from '../../molecules/InputItem';
import { Trans, useTranslation } from 'react-i18next';
import H3 from '../../atoms/title/H3';
import styled from 'styled-components';
import HelperText from '../../atoms/HelperText';
import Paragraph from '../../atoms/Paragraph';
const StyledHelperText = styled(HelperText) `
    display: block;
    margin-top: -15px;
`;
const PersonalDetails = ({ data, errors, setData, emailDomain, disabled = false, emailInputDisabled = false, }) => {
    const { t } = useTranslation();
    const handleChange = (e) => {
        setData(e.currentTarget.name, e.currentTarget.value);
    };
    return (_jsxs(_Fragment, { children: [_jsx(H3, { children: t('users.personal_information_title') }), emailInputDisabled && (_jsx(Paragraph, { children: t('users.email_disabled') })), _jsx(InputItem, { label: t('user.full_name_label'), placeholder: t('user.full_name_placeholder'), type: "text", name: "full_name", onChange: handleChange, error: errors?.full_name, value: data?.full_name, disabled: disabled, required: true }), _jsx(InputItem, { label: t('user.email'), placeholder: t('user.given_name_placeholder'), suffix: '@' + emailDomain, type: "text", name: "email", onChange: handleChange, error: errors?.email, value: data?.email, disabled: disabled || emailInputDisabled, pattern: "[^@]+" // all characters except @
                , required: true }), _jsx(StyledHelperText, { children: _jsx(Trans, { i18nKey: "user.domain_limit_hint" }) })] }));
};
export default PersonalDetails;
